import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Define an empty api slice to populate with endpoints later
export const apiSlice = createApi({
  // The cache reducer expects to be added at `state.api` (already default - this is optional)
  reducerPath: 'api',
  baseQuery: fetchBaseQuery(),
  endpoints: () => ({}),
});
